import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import swal from 'sweetalert';
import PageContentLayout from 'components/PageContentLayout';
import { handleHTTPError, showLoader, showMessage } from 'store/actions';
import { activePartner, blockPartner, readPartner, resetPartnerPwd, updatePartner } from 'apis';
import { Button, Col, Row } from 'reactstrap';
import TextBox from 'components/controls/TextBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Constants } from 'utils/constants';
import { validateEmail } from 'utils';

class PartnerDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            partner: null,
            name: '',
            email: '',
            phoneNumber: '',
            password: '',
            confirmPassword: '',
            profileValidate: false,
            pwdValidate: false,
        };
    }

    componentDidMount = () => {
        this.getPartner();
    };

    getPartner = async () => {
        const partnerId = this.props.match.params?.id;
        try {
            this.props.showLoader(true);
            const { data } = await readPartner({ _id: partnerId });
            this.setState({
                partner: data,
                name: data.name,
                email: data.email,
                phoneNumber: data.phoneNumber,
            });
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.props.showLoader(false);
        }
    };

    save = async () => {
        this.setState({ profileValidate: true });
        const { name, email, phoneNumber } = this.state;
        if (!name || !email || !validateEmail(email)) return;
        try {
            this.props.showLoader(true);
            const { data } = await updatePartner({ _id: this.state.partner._id, name, email, phoneNumber });
            this.setState({
                partner: data,
                name: data.name,
                email: data.email,
                phoneNumber: data.phoneNumber,
            });
            this.props.showMessage({
                show: true,
                message: { type: 'success', text: 'Profile has been saved.' },
            });
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.props.showLoader(false);
        }
    };

    block = async () => {
        let ok = await swal({
            title: 'Confirm',
            text: 'Do you want to block this partner?\n Are you sure?',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        });
        if (!ok) return;
        try {
            this.props.showLoader(true);
            const params = { _id: this.state.partner._id };
            const { data } = await blockPartner(params);
            this.props.showMessage({
                show: true,
                message: { type: 'success', text: `${this.state.partner.name} has been blocked` },
            });
            this.setState({ partner: data });
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.props.showLoader(false);
        }
    };

    active = async () => {
        let ok = await swal({
            title: 'Confirm',
            text: 'Do you want to active this partner?\n Are you sure?',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        });
        if (!ok) return;
        try {
            this.props.showLoader(true);
            const params = { _id: this.state.partner._id };
            const { data } = await activePartner(params);
            this.props.showMessage({
                show: true,
                message: { type: 'success', text: `${this.state.partner.name} has been activated` },
            });
            this.setState({ partner: data });
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.props.showLoader(false);
        }
    };

    resetPwd = async () => {
        try {
            this.setState({ pwdValidate: true });
            const { password, confirmPassword } = this.state;
            if (!password || !confirmPassword || password !== confirmPassword) return;
            this.props.showLoader(true);
            const params = { _id: this.state.partner._id, newPassword: password };
            await resetPartnerPwd(params);
            this.props.showMessage({
                show: true,
                message: { type: 'success', text: 'Password has been reset.' },
            });
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.props.showLoader(false);
        }
    };

    render() {
        const { partner, name, email, phoneNumber, password, confirmPassword, profileValidate, pwdValidate } =
            this.state;
        if (!partner) return null;

        return (
            <PageContentLayout
                header={
                    <div className="d-flex justify-content-between align-items-baseline">
                        <h1 className="font-weight-bold">{partner?.name}</h1>
                        <Button color="primary" onClick={() => this.props.history.goBack()}>
                            <FontAwesomeIcon icon="arrow-left" className="mr-2" /> Back
                        </Button>
                    </div>
                }
            >
                <h2 className="font-weight-bold">Profile</h2>
                <Row>
                    <TextBox
                        label="Name"
                        id="name"
                        name="name"
                        className="col-md-3 mb-3"
                        type="text"
                        validate={profileValidate}
                        value={name}
                        required
                        placeholder="iPlayme2"
                        onBlur={(e) => {}}
                        onChange={(name, e) => {
                            this.setState({ name });
                        }}
                        validationOption={{
                            showMsg: false,
                            check: true,
                            required: true,
                        }}
                    />
                    <TextBox
                        label="Email Address"
                        id="email"
                        name="email"
                        className="col-md-3 mb-3"
                        type="text"
                        validate={profileValidate}
                        value={email}
                        required
                        placeholder="partner@mail.com"
                        onBlur={(e) => {}}
                        onChange={(email, e) => {
                            this.setState({ email });
                        }}
                        validationOption={{
                            showMsg: false,
                            reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            check: true,
                            required: true,
                        }}
                    />
                    <TextBox
                        label="Phone Number"
                        id="phoneNumber"
                        name="phoneNumber"
                        className="col-md-3 mb-3"
                        type="text"
                        validate={profileValidate}
                        value={phoneNumber}
                        placeholder="partner@mail.com"
                        onBlur={(e) => {}}
                        onChange={(phoneNumber, e) => {
                            this.setState({ phoneNumber });
                        }}
                        validationOption={{
                            showMsg: false,
                            check: false,
                            required: false,
                        }}
                    />
                    <TextBox
                        label="Status"
                        id="status"
                        name="status"
                        className="col-md-3 mb-3"
                        type="text"
                        value={partner.status.toUpperCase()}
                        disabled
                    />
                    <Col md={12} className="d-flex justify-content-end align-items-center">
                        {this.state.partner.status === Constants.ACCOUNT_STATUS.ACTIVE ? (
                            <Button
                                color="secondary"
                                style={{ width: '100px' }}
                                disabled={this.props.isLoader}
                                onClick={this.block}
                            >
                                <FontAwesomeIcon icon="ban" className="mr-2" /> Block
                            </Button>
                        ) : (
                            <Button
                                color="primary"
                                style={{ width: '100px' }}
                                disabled={this.props.isLoader}
                                onClick={this.active}
                            >
                                <FontAwesomeIcon icon="check" className="mr-2" /> Active
                            </Button>
                        )}
                        <Button
                            color="primary"
                            style={{ width: '100px' }}
                            disabled={this.props.isLoader}
                            onClick={this.save}
                        >
                            <FontAwesomeIcon icon="save" className="mr-2" /> Save
                        </Button>
                    </Col>
                </Row>
                <hr className="my-4"></hr>
                <h2 className="font-weight-bold">Reset Password</h2>
                <Row>
                    <TextBox
                        label="New Password"
                        id="password"
                        name="password"
                        type="password"
                        className="col-md-3 mb-3"
                        validate={pwdValidate}
                        required
                        value={password}
                        placeholder="Password"
                        onBlur={(e) => {}}
                        onChange={(password, e) => {
                            this.setState({ password });
                        }}
                        validationOption={{
                            showMsg: false,
                            check: true,
                            required: true,
                        }}
                    />
                    <TextBox
                        label="Confirm Password"
                        id="confirmPassword"
                        name="confirmPassword"
                        type="password"
                        className="col-md-3 mb-3"
                        validate={pwdValidate}
                        value={confirmPassword}
                        required
                        placeholder="Password"
                        onBlur={(e) => {}}
                        onChange={(confirmPassword, e) => {
                            this.setState({ confirmPassword });
                        }}
                        validationOption={{
                            showMsg: false,
                            compare: password,
                            check: true,
                            required: true,
                        }}
                    />
                    <Col className="d-flex align-items-end">
                        <Button color="secondary" className="mb-3" style={{ width: '100px' }} onClick={this.resetPwd}>
                            Reset
                        </Button>
                    </Col>
                </Row>
            </PageContentLayout>
        );
    }
}

const mapStateToProps = ({ ui }) => {
    const { isLoader } = ui;
    return { isLoader };
};

export default withRouter(
    connect(mapStateToProps, {
        showLoader,
        showMessage,
        handleHTTPError,
    })(PartnerDetails),
);
